import { createContext, useContext } from 'react';

export const ActiveTabContext = createContext<string | undefined>(undefined);

export const useActiveTab = () => {
    const ctx = useContext(ActiveTabContext);
    if (!ctx) {
        throw new Error('ActiveTabContext must be set.');
    }

    return ctx || '';
};
